// optimize loading fonts https://goo.gl/oRysqV
import FontFaceObserver from 'fontfaceobserver';

let cacheFonts = false
try {
  cacheFonts = sessionStorage.fontsLoaded;
} catch (error) {
  console.error(error);
}

const regular = new FontFaceObserver('PF DinDisplay Pro Regular');
const medium = new FontFaceObserver('PF DinDisplay Pro Medium');
const bold = new FontFaceObserver('PF DinDisplay Pro Bold');
const html = document.documentElement;

html.classList.add('FontsLoading');

Promise.all([regular.load(), medium.load(), bold.load()])
  .then(() => {
    html.classList.remove('FontsLoading');
    html.classList.add('FontsLoaded');
    cacheFonts = true;
    console.info('All fonts loaded', 'sessionStorage fonts loaded: ', cacheFonts);
  })
  .catch(() => {
    html.classList.remove('FontsLoading');
    html.classList.add('FontsFailed');
    cacheFonts = false;
    console.info('All fonts not loaded', 'sessionStorage fonts loaded: ', cacheFonts);
  });

if (cacheFonts) {
  html.classList.add('FontsLoaded');
}
